<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2l4S9H/tc-custom/9781467439084.jpg?1737196287630" alt="This image is the cover for the book Deuteronomy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Deuteronomy
      </h1>
      <p class="bookDescription body article font2">
        <p>This milestone commentary by Jack Lundbom is intended for any and all readers who want to better know and understand the key Pentateuchal book of Deuteronomy, which has had a huge influence on both Judaism and Christianity over the centuries. For Jews Deuteronomy contains the Decalogue and the <i>Shema</i> -- “Hear, O Israel, the Lord our God is one” (6:4) -- supplemented by a code of primal legislation.<br/><br/>Deuteronomy is much cited in the New Testament and has come to occupy an important place in the life and doctrine of the Christian church. It lifts up important wisdom themes such as humane treatment and benevolence to the poor and needy and is rich in theology, calling repeatedly on Israel to reject other gods and worship the Lord alone as holy.<br/><br/>Besides drawing on language, archaeology, and comparative Near Eastern material, Lundbom’s commentary employs rhetorical criticism in explicating the biblical text. Lundbom also cites later Jewish interpretation of the book of Deuteronomy and makes numerous New Testament connections. An appendix contains all citations of Deuteronomy in the New Testament.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jack R. Lundbom
      </h2>
      
      <p class="authorDescription body article">Jack R. Lundbom is a life member at Clare Hall, CambridgeUniversity. Among his prior publications are JeremiahCloser Up and The Hebrew Prophets: AnIntroduction.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5ac4d0de